import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { can, canSeePayments } from "@/lib/permissions";

/**
 * Wrap a route element: renders it only if the user has the capability,
 * otherwise redirects to the dashboard. `cap` may be a capability string or a
 * function (user) => boolean. The backend enforces the same rules; this just
 * stops users landing on a page that would only show 403s.
 */
export default function RequireCap({ cap, children }) {
  const { user, loading } = useAuth();
  if (loading || !user) return children; // AppLayout handles the not-logged-in case
  const ok = typeof cap === "function" ? cap(user) : can(user, cap);
  return ok ? children : <Navigate to="/app/dashboard" replace />;
}

export const payments = (u) => canSeePayments(u);
